import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import doctorReducer from './slices/doctorSlice';
import officerReducer from './slices/officerSlice';
import appointmentReducer from './slices/appointmentSlice';
import uiReducer from './slices/uiSlice';
import dashboardReducer from './slices/dashboardSlice';
import prescriptionReducer from './slices/prescriptionSlice';
import visitReportReducer from './slices/visitReportSlice';
import patientProfileReducer from './slices/patientProfileSlice';

/**
 * Redux Store Configuration
 * Configures the Redux store with all reducers and middleware.
 *
 * @author Civilhealth Development Team
 */
export const store = configureStore({
  reducer: {
    auth: authReducer,
    doctor: doctorReducer,
    officer: officerReducer,
    appointment: appointmentReducer,
    ui: uiReducer,
    dashboard: dashboardReducer,
    prescription: prescriptionReducer,
    visitReport: visitReportReducer,
    patientProfile: patientProfileReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: import.meta.env.DEV,
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;